import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	getLayersErrorTitle: {
		id: 'eoc-schedule.controllers.schedule-store.actions.get-layers-error-title',
		defaultMessage: 'An error occurred',
		description: 'A message which indicates that an error is occurred',
	},
	getLayersErrorDescription: {
		id: 'eoc-schedule.controllers.schedule-store.actions.get-layers-error-description',
		defaultMessage: "Schedule couldn't be loaded, please try again later.",
		description: 'A message that indicates we could not fetch the schedule',
	},
	takeOnCallErrorTitle: {
		id: 'eoc-schedule.controllers.schedule-store.actions.take-oncall-error-title',
		defaultMessage: 'We could not create the override at this moment. Please try again.',
		description:
			'This message indicates that our back-end services did not respond when adding an override.',
	},
	takeOnCallSuccessTitle: {
		id: 'eoc-schedule.controllers.schedule-store.actions.take-oncall-success-title',
		defaultMessage: 'You are now on-call for all rotations for the next one hour.',
		description: 'This message indicates override is successfully created.',
	},
	addOverrideErrorTitle: {
		id: 'eoc-schedule.controllers.schedule-store.actions.add-override-error-title',
		defaultMessage: 'We could not create the override at this moment. Please try again.',
		description:
			'This message indicates that our back-end services did not respond when adding an override.',
	},
	addOverrideSuccessTitle: {
		id: 'eoc-schedule.controllers.schedule-store.actions.add-override-success-title',
		defaultMessage: 'Override is created successfully.',
		description: 'This message indicates override is successfully created.',
	},
	addOverrideBulkErrorTitle: {
		id: 'eoc-schedule.controllers.schedule-store.actions.add-override-bulk-error-title',
		defaultMessage: 'We could not create the override at this moment. Please try again.',
		description:
			'This message indicates that our back-end services did not respond when adding a bulk override.',
	},
	addOverrideBulkSuccessTitle: {
		id: 'eoc-schedule.controllers.schedule-store.actions.add-override-bulk-success-title',
		defaultMessage: 'Selected participants overriden successfully.',
		description: 'This message indicates bulk overrides are successfully overriden.',
	},
	updateOverrideErrorTitle: {
		id: 'eoc-schedule.controllers.schedule-store.actions.update-override-error-title',
		defaultMessage: 'We could not create the override at this moment. Please try again.',
		description:
			'This message indicates that our back-end services did not respond when updating an override.',
	},
	updateOverrideSuccessTitle: {
		id: 'eoc-schedule.controllers.schedule-store.actions.update-override-success-title',
		defaultMessage: 'Override updated successfully.',
		description: 'This message indicates override is successfully updated.',
	},
	getOverrideErrorTitle: {
		id: 'eoc-schedule.controllers.schedule-store.actions.get-override-error-title',
		defaultMessage: 'We could not retrieve the override details at this moment. Please try again.',
		description:
			'This message indicates that our back-end services did not respond when retrieving override details.',
	},
	revertOverrideSuccessTitle: {
		id: 'eoc-schedule.controllers.schedule-store.actions.revert-override-success-title',
		defaultMessage: 'Override removed successfully.',
		description: 'This message indicates override is successfully updated.',
	},
	revertOverrideErrorTitle: {
		id: 'eoc-schedule.controllers.schedule-store.actions.revert-override-error-title',
		defaultMessage: 'We could not removed the override at this moment. Please try again.',
		description:
			'This message indicates that our back-end services did not respond when removing an override.',
	},
});
